

const CardroomSubscriptionEditor = ({ cardroom }) => {
    return "Coming soon..."
};


export default CardroomSubscriptionEditor;